import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useCallCenterContext } from "@/context/call.center.context";
import { CALLCENTER_USER_STATUS_NOT_AVAILABLE, CALLCENTER_USER_STATUS_READY } from "@icebergeradmin/common";
import { Check, ChevronDown, X } from "lucide-react";
import React from "react";

type StatusOption = {
  value: number;
  label: string;
  icon: React.ReactNode;
};

const statusOptions: StatusOption[] = [
  {
    value: CALLCENTER_USER_STATUS_READY,
    label: "I'm Ready!",
    icon: (
      <div className="bg-blue-400 rounded-full p-1">
        <Check className="h-3 w-3 xl:h-4 xl:w-4" />
      </div>
    ),
  },
  {
    value: CALLCENTER_USER_STATUS_NOT_AVAILABLE,
    label: "Not Available",
    icon: (
      <div className="bg-red-400 rounded-full p-1">
        <X className="h-3 w-3 xl:h-4 xl:w-4" />
      </div>
    ),
  },
];

export function StatusDropdown() {
  const { agentStatus, updateAgentStatus } = useCallCenterContext();
  let currentOption = statusOptions.find((option) => option.value === agentStatus);
  // for now falback is always I'm ready
  if (!currentOption) currentOption = statusOptions.find((i) => i.value === CALLCENTER_USER_STATUS_READY);

  const handleStatusChange = (newStatus?: number) => {
    updateAgentStatus(newStatus);
  };

  if (typeof agentStatus !== "number") return <div className="text-xs">loading...</div>;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className="bg-slate-800 border-slate-700 text-white hover:bg-slate-700 hover:text-white px-2 2xl:px-4 py-2 rounded-lg flex items-center gap-2 min-w-[100px] xl:min-w-[140px] justify-between ring-0 focus-visible:ring-0 focus-visible:outline-none"
        >
          <div className="flex items-center gap-2">
            {currentOption?.icon}
            <span className="text-[12px] xl:text-sm font-medium">{currentOption?.label}</span>
          </div>
          <ChevronDown className="h-2 w-2 xl:h-4 xl:w-4 text-gray-400" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-slate-800 border-slate-700 text-white min-w-[140px]" align="start">
        {statusOptions.map((option) => (
          <DropdownMenuItem
            key={option.value}
            onClick={() => handleStatusChange(option.value)}
            className="hover:bg-slate-700 focus:bg-slate-700 cursor-pointer px-3 py-2"
          >
            <div className="flex items-center gap-2">
              {option.icon}
              <span className="text-[12px] xl:text-sm whitespace-nowrap">{option.label}</span>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
